import Order from "@system/config/order";
import store from "src/storeWire";
import { setPlaceOrderLoading } from "src/store/slice/model/Order";
import System from "src/helper/system";
import Api from "./APIHandler";
import Helper from "src/helper/Helper";
import { __remove, __set } from "src/store/axios_indicator";
import liveAuth from "src/helper/liveAuth";
import Checkout from "@system/config/checkout";
import Constants from "src/helper/Constants";
import { SET_CART_WEB_ORDER_ID } from "src/store/slice/model/Cart";

const { avUserInfoData: { email }, storageName: { CART_ID } } = System
const API = new Api({});
class OrderAPICall {

    fetchOrderList = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = { ...params }
        await API.post(Order.ORDER_LISTING, param).then((resHer) => {
            res = resHer.data.data;
        });

        if (res === null) {
            return {}
        } else {
            let data_to_send = {
                totalOrderList: 0,
                orderList: [],
                continuationToken: ''
            };

            if (res.count !== undefined) {
                data_to_send.totalOrderList = res.count
            }
            if (res.continuationToken) {
                data_to_send.continuationToken = res.continuationToken
            }
            if (res.data !== undefined && res.data.length > 0) {
                data_to_send.orderList = res.data
            }
            return data_to_send
        }
    };

    fetchOrderDetail = async (params = {}) => {
        __set('GET_ORDER_DETAIL');

        let res = {};
        let param = {}
        param.params = { ...params }

        await API.get(Order.ORDER_DETAIL, param).then((resHer) => {
            if (resHer.data.isSuccessFull === true) {
                res = resHer.data.data;
                res.orderItemByShipment?.map(val => {
                    val.orderItems?.map(j => {
                        j.uniqueNumber = Helper.UUID()
                    })
                })

                res.orderItems?.map(val => {
                    val.uniqueNumber = Helper.UUID()
                })
            }
            __remove('GET_ORDER_DETAIL');
        }).catch((e) => {
            __remove('GET_ORDER_DETAIL');
        })

        return res;
    };

    sendEmailSalesRepresentativeOrder = async (params = {}) => {
        __set('TAX_EXEMPT_FILE_UPLOAD');
        let res = {};
        let param = {}
        param.data = { ...params }
        await API.post(Order.ORDER_EMAIL_SALES_REPRESENTATIVE, param).then((resHer) => {
            res = resHer.data.data;
            __remove('TAX_EXEMPT_FILE_UPLOAD');
        }).catch((e) => {
            __remove('TAX_EXEMPT_FILE_UPLOAD');
        })
        return res;
    };

    sendOrderItemEmail = async (params = {}) => {
        __set('SEND_ORDER_ITEM_EMAIL');
        let res = false
        let param = {}
        param.data = { ...params }
        await API.post(Order.ORDER_ITEM_EMAIL, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = true
            }
            __remove('SEND_ORDER_ITEM_EMAIL');
        }).catch((e) => {
            __remove('SEND_ORDER_ITEM_EMAIL');
        })
        return res;
    };

    sendOrderPOLineItemEmail = async (params = {}) => {
        let res = {};
        let param = {};
        param.data = { ...params }
        await API.post(Order.ORDER_PO_LINE_ITEM_EMAIL, param).then((resHer) => {
            res = resHer.data.data;
        });
        return res;
    }


    placeYourOrder = async (params = {}) => {
        let res = {};
        if (!liveAuth.check()) {
            return res;
        }

        let param = {}
        param.data = { ...params }
        if (!param.data.emailAddress) {
            param.data.emailAddress = email
        }
        if (!param.data.cartId) {
            param.data.cartId = localStorage.getItem(CART_ID)
        }

        if (param.data.orderPlaced === true) {
            store.dispatch(setPlaceOrderLoading(true))
        }

        try {
            await API.post(Order.PLACE_YOUR_ORDER, param).then((resHer) => {
                if (resHer.data && resHer.data.data) {
                    res = resHer.data.data;
                    if (res?.webOrderNumber) {
                        store.dispatch(SET_CART_WEB_ORDER_ID({
                            WEB_ORDER_ID: res?.webOrderNumber
                        }));
                    }
                }
            }).catch((e) => {
                res = e?.response?.data
            })
        } catch (error) {
            res = error?.response?.data
        }
        return res
    };

    fetchPlaceOrderItems = async (orderId) => {
        let res = {};
        let URL = Order.PLACE_ORDER_ITEMS + '?orderId=' + orderId
        let c = System?.getParams()
        if (c?.currentCurrency) {
            URL = URL + '&currentCurrency=' + c?.currentCurrency
        }
        await API.get(URL, {}).then((resHer) => {
            if (resHer.data.isSuccessFull === true) {
                res = resHer.data.data;
            }
        }).catch((e) => {
            console.log(e)
        })

        return res
    };

    orderDownloadInvoice = async (params = {}) => {
        __set('ORDER_DOWNLOAD_API_CALL');
        let res = {};
        let param = {}
        param.data = { invoiceNumber: params }
        param.data.responseType = 'blob'
        await API.post(Order.ORDER_DOWNLOAD_INVOICE, param).then(async (response) => {
            Helper.downloadFileFromRes(response.data, params?.length > 1 ? 'ORDER.zip' : 'ORDER.pdf');
            __remove('ORDER_DOWNLOAD_API_CALL');
        }).catch((e) => {
            __remove('ORDER_DOWNLOAD_API_CALL');
        })
        return res;
    };

    exportOrder = async (params = false) => {
        __set('ORDER_DOWNLOAD_API_CALL');
        let res = {};
        const param = {}
        param.params = params

        await API.post(Order.EXPORT_ORDER, param).then(async (response) => {
            if (!params.isEmail) {
                Helper.downloadFileFromRes(response.data, 'Order_export.csv')
            }
            __remove('ORDER_DOWNLOAD_API_CALL');
        }).catch((e) => {
            __remove('ORDER_DOWNLOAD_API_CALL');
        })
        return res;
    };

    exportEmail = async (params = false) => {
        __set('ORDER_DOWNLOAD_API_CALL');
        let res = {};
        let param = {}
        param.data = params
        await API.post(Order.EXPORT_EMAIL, param).then(async (response) => {
            if (response.data.isSuccessFull) {
                res = response.data.isSuccessFull
            }
            __remove('ORDER_DOWNLOAD_API_CALL');
        }).catch((e) => {
            __remove('ORDER_DOWNLOAD_API_CALL');
        })
        return res;
    };

    exportEmailSales = async (params = false) => {
        __set('ORDER_DOWNLOAD_API_CALL');
        let res = false;
        let param = {}
        param.data = params
        await API.post(Order.ORDER_EMAIL_SALES, param).then(async (response) => {
            if (response.data.isSuccessFull) {
                res = true
            }
            __remove('ORDER_DOWNLOAD_API_CALL');
        }).catch((e) => {
            __remove('ORDER_DOWNLOAD_API_CALL');
        })
        return res;
    };

    getExportOrderCount = async () => {
        let res = 0;
        await API.post(Order.ORDER_EXPORT_COUNT, {}).then(async (resHer) => {
            if (resHer.data.isSuccessFull === true) {
                res = Number(resHer.data.data.count);
            }
        });

        return res;
    }

    fetchManufacturerList = async () => {
        let res = {};
        await API.post(Order.ORDER_MANUFACTURE_LIST, {}).then((resHer) => {
            res = resHer.data.data;
        });

        return res;
    };


    getValidateOrderFromServer = async (params) => {
        let res = {};
        if (!liveAuth.check()) {
            return res;
        }

        let param = {}
        param.data = {
            "cartId": localStorage.getItem(CART_ID),
            "shipToAddressId": params.shipToAddressId,
            "type": Constants.CartType.SHOPPING
        }
        await API.post(Checkout.ORDER_VALIDATE, param).then((resHer) => {
            if (resHer?.data?.data) {
                res = resHer.data?.data || {}
            }
        });

        return res
    };

    getOrderItemList = async (params) => {
        let res = {};
        if (!liveAuth.check()) {
            return res;
        }

        let param = {}
        param.data = params
        await API.post(Order.GET_ORDER_ITEM_LIST, param).then((resHer) => {
            if (resHer?.data?.data) {
                res = resHer.data?.data || []
            }
        });

        return res
    };
    billingCurrencyConversion = async (params) => {
        let res = {};
        if (!liveAuth.check()) {
            return res;
        }

        let param = {}
        param.data = params
        await API.post(Order.BILLING_CURRENCY_CONVERSION, param).then((resHer) => {
            if (resHer?.data?.data) {
                res = resHer.data?.data || []
            }
        });

        return res
    };
    orderCancellationEmail = async (params) => {
        let res = {};
        if (!liveAuth.check()) {
            return res;
        }

        let param = {}
        param.data = params
        await API.post(Order.ORDER_CANCELLATION_EMAIL, param).then((resHer) => {
            if (resHer?.data?.data) {
                res = resHer.data?.isSuccessFull
            }
        });

        return res
    };
}

export default OrderAPICall;